export default value => {
  if (typeof (value) !== `boolean`) return false
  return value
}
